import styled from 'styled-components';

import DeleteIcon from '@material-ui/icons/Delete';

import THEME from '../../../../../../../constants/theme';
import Card from '../../../../../../../components/Card/Card';

export const Bag = styled(Card)`
  flex: 1 0 21%;
  border-radius: 0 !important;
  flex-direction: row !important;
  margin-bottom: 10px !important;
  margin-right: 8px;
  margin-top: 10px !important;
  width: 190px !important;
  min-width: 170px;
`;

export const BagImage = styled.img`
  height: 64px;
  width: 64px;
`;

export const Column = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-left: 10px;
  margin-top: 10px;
`;

export const Delete = styled(DeleteIcon)`
  color: ${THEME.grey};
  cursor: pointer;
`;

export const Span = styled.span`
  color: ${THEME.grey};
  margin-right: 10px;
`;

export const Status = styled.p`
  color: ${props => props.color};
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.3px;
  line-height: 1.43;
  margin: 0;
`;

export const Text = styled.p`
  color: ${THEME.bobBlack};
  display: flex;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  margin: 0;
`;
